<!-- <header class="navbar sticky-top flex-md-nowrap p-0 shadow-sm">
  <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6" href="#">Company name</a>
  <span class="navbar-toggler-icon me-auto"></span>

  <div class="navbar-nav">
      <div class="nav-item text-nowrap">
          <a class="nav-link px-3" href="#">Sign out</a>
      </div>
  </div>
</header> -->
<nav class="navbar navbar-expand-md navbar-dark fixed-top p-0 shadow-sm">
    <div class="container-fluid">
        <div class="d-flex">
            <div class="navbar-nav pe-3 ps-1" (click)="DataTableRerender()">
                <i class="bi bi-list link-dark fs-3" (click)="ExpandedMenu = !ExpandedMenu"></i>
            </div>
            <a href="/" class="mb-md-0 me-md-auto link-dark text-decoration-none">
                <img [src]="user.CompanyLogo" alt="Company Logo" style="max-width: 170px;max-height: 40px;" />
            </a>
            <span class="cursor-pointer ms-4" style="align-content:center;color:#0078D4;" (click)="moduleList()" *ngIf="user.UserType == 'A' && this.common.CompanyParameterValue.AllModulesRights"><i class="bi bi-ui-checks-grid"></i> Switch Module</span>
        </div>
        <!-- <button class="navbar-toggler link-dark" type="button" data-toggle="collapse" data-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <i class="bi bi-list link-dark fs-3" (click)="ExpandedMenu = !ExpandedMenu"></i>
        </button> -->
        <div class="" id="navbarsExample02">
            <div class="d-flex align-items-center">
                <span class="CompanyName mx-2" (click)="CompanySelection()">{{displayCompanyName}}</span>
                <div ngbDropdown>
                    <i *ngIf="this.user.UserType === 'A'"
                        class="bi bi-file-person link-dark position-relative fs-5 mt-1 px-2 cursor-pointer"
                        (click)="search()"></i>
                    <i type="button" class="bi bi-bell link-dark position-relative fs-5 mt-2"
                        (click)="openNotification(dNotification)">

                        <span class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                            style="font-size: 10px;" *ngIf="common.NotificationCount>0">
                            {{common.NotificationCount>99?'99+':common.NotificationCount}}
                        </span>
                    </i>

                    <!-- <i type="button" class="bi bi-bell link-dark position-relative fs-5 mt-2" id="Notificationpop"
                        (click)="NotificationGetUnread('D')" ngbDropdownToggle>
                        <span class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-danger"
                            style="font-size: 10px;">
                            {{common.NotificationCount>99?'99+':common.NotificationCount}}
                        </span>
                    </i> -->
                    <div ngbDropdownMenu aria-labelledby="Notificationpop" display="dynamic"
                        style="width: 25rem;max-height:27rem;left: -18rem;">
                        <div class="row" style="display: contents;">
                            <label *ngIf="Notifications.length == 0">No new notification</label>
                            <div class="col-12 p-0" style="max-height: 24rem;">
                                <div class="tile m-1" *ngFor="let Notification of Notifications; let i = index">
                                    <div class="row p-1 m-1 cursor-pointer" style="background-color: #EBF3FE;"
                                        (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'],true)">
                                        <div class="col-2">
                                            <img [src]="common.PhotoLink('')" alt="user-image" width="35"
                                                class="rounded-circle">
                                        </div>
                                        <div class="col-9">
                                            <div style="font-size: smaller;font-weight: 500;color: #0078D4;">
                                                <div class="row">
                                                    <div class="col">{{Notification['Title']}}</div>
                                                    <div class="col-auto badge danger"
                                                        *ngIf="Notification['ImportantNotification']">Important</div>
                                                </div>
                                            </div>
                                            <div style="font-size: smaller">{{Notification['NotificationBody']}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <button style="width: 100%;" type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/notification']">View All</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nav-item text-nowrap ps-3">
                    <li ngbDropdown class="dropdown list-unstyled">
                        <span class="nav-link link-dark dropdown-toggle arrow-none nav-user px-2 align-items-center"
                            id="dropdownProfile" role="button" style="display: inline-flex;" ngbDropdownToggle>
                            <span class="account-user-avatar me-2">

                                <img *ngIf="user.EPhoto != null && user.EPhoto != ''"
                                    [src]="common.PhotoLink(user.EPhoto)" alt="user-image" width="35"
                                    class="rounded-circle" />
                                <div *ngIf="user.EPhoto == null || user.EPhoto == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(user.UserName)}}
                                    </div>
                                </div>
                            </span>
                            <span class="d-lg-flex flex-column gap-0 d-none">
                                <span class="link-dark">{{user.UserName}}</span>
                                <span class="link-dark" style="font-size: small;">{{user.EDesignation}} <span
                                        *ngIf="user.EmpCode != '' && user.EmpCode != null">#({{user.EmpCode}})</span></span>
                            </span>
                        </span>
                        <div ngbDropdownMenu aria-labelledby="dropdownProfile"
                            [ngStyle]="{ 'left':this.common.IsMobile()?'-7rem':''}">
                            <!-- item-->
                            <div class=" dropdown-header noti-title">
                                <h6 class="text-overflow m-0">Welcome !</h6>
                            </div>

                            <!-- item-->
                            <span class="dropdown-item" (click)="CompanySelection()" *ngIf="this.user.UserType == 'A'">
                                <i class="bi-buildings-fill me-1"></i>
                                <span>Change Company</span>
                            </span>

                            <!-- item-->
                            <span class="dropdown-item" (click)="ESS_GetLoginDetails(false)"
                                *ngIf="this.user.UserType == 'E'">
                                <i class="bi bi-lock me-1"></i>
                                <span>MPIN</span>
                            </span>

                            <!-- item-->
                            <span class="dropdown-item" (click)="ChangePassword()" *ngIf="this.user.UserType == 'E'">
                                <i class="bi bi-shield-lock me-1"></i>
                                <span>Change Password</span>
                            </span>

                            <!-- item-->
                            <span class="dropdown-item" (click)="Logout()">
                                <i class="bi bi-box-arrow-right me-1"></i>
                                <span>Logout</span>
                            </span>
                        </div>
                    </li>
                </div>
            </div>
        </div>
    </div>
</nav>

<main class="d-flex flex-nowrap main-container">
    <div class="sidemenu d-flex flex-column flex-shrink-0 p-2 bg-primary bg-gradient px-2"
        [ngClass]="{'nav-width': ExpandedMenu,'align-items-center':!ExpandedMenu}">
        <div class="input-group" *ngIf="ExpandedMenu">
            <div class="input-group-text"><i class="bi bi-search"></i></div>
            <input (keyup)="SearchonKey($event)" [(ngModel)]="searchtext" name="searchtext" type="text"
                class="form-control" id="txtSearchHere" placeholder="Search Here">
        </div>
        <div class="overflow-auto">
            <ul class="nav nav-pills flex-column mb-auto">
                @for (menu of menus; track setIsCollapsed(menu); let i = $index;) {
                @if((menu.SubMenus.length > 0 || menu.ESS_MenuMasterId == 1) && menu.ESS_MenuMasterId != 80){
                <li>
                    <span class="nav-link link-light p-2" aria-current="page"
                        (click)="collapsemenu.toggle();this.ExpandedMenu = true;"
                        [attr.aria-expanded]="!menu.isCollapsed">
                        <i [ngClass]="menu.Icon" class="p-1"></i>
                        <label *ngIf="ExpandedMenu" class="main-menu ms-2">{{menu.MenuLabel}}
                            &nbsp;&nbsp;<span
                                *ngIf="(menu.ESS_MenuMasterId == 32 || menu.ESS_MenuMasterId == 97) && common.TotalPendingCount > 0">
                                <span class="badge bg-danger link-dark float-end mt-1"
                                    style="font-size: 10px;height: fit-content;">{{
                                    common.TotalPendingCount}}</span>
                            </span>
                        </label>

                        <i *ngIf="ExpandedMenu" class="bi me-2 p-1 float-end"
                            [ngClass]="{'bi-chevron-down': menu.isCollapsed,'bi-chevron-up':!menu.isCollapsed}"
                            style="font-size: small;"></i>
                    </span>
                    <div #collapsemenu="ngbCollapse" [(ngbCollapse)]="menu.isCollapsed" class="ps-2">
                        <ul class="pb-1 link-light small" *ngIf="ExpandedMenu">
                            @if (menu.ESS_MenuMasterId == 1) {
                            <li class="nav-item" [routerLink]="['/dashboard/front']" [routerLinkActive]="['active']"
                                (click)="autoExpandedMenu()">
                                <span class="nav-link link-light p-1" aria-current="page"
                                    [attr.aria-expanded]="!menu.isCollapsed">
                                    <label class="sub-menu">Dashboard-Front</label>
                                </span>
                            </li>
                            }
                            @for (submenu1 of menu.SubMenus; track setIsCollapsed(submenu1); let j = $index;) {
                            @if(submenu1.SubMenus.length > 0 && submenu1.ESS_MenuMasterId != 59 &&
                            submenu1.ESS_MenuMasterId != 60){
                            <li class="nav-item">
                                <span class="nav-link link-light p-1 d-flex" aria-current="page"
                                    [attr.aria-expanded]="!submenu1.isCollapsed"
                                    (click)="collapsesubmenu1.toggle();this.ExpandedMenu = true;">
                                    <label class="sub-menu">{{submenu1.MenuLabel}}</label>
                                    <i *ngIf="ExpandedMenu" class="bi me-2 p-1 float-end"
                                        [ngClass]="{'bi-chevron-down': submenu1.isCollapsed,'bi-chevron-up':!submenu1.isCollapsed}"
                                        style="font-size: small;"></i>
                                </span>

                                <div #collapsesubmenu1="ngbCollapse" [(ngbCollapse)]="submenu1.isCollapsed">
                                    <ul class="pb-1 link-light small" *ngIf="ExpandedMenu">
                                        @for (submenu2 of submenu1.SubMenus; track setIsCollapsed(submenu2); let k =
                                        $index;) {
                                        @if(submenu2.SubMenus.length > 0){
                                        <li class="nav-item">
                                            <span class="nav-link link-light p-1 d-flex" aria-current="page"
                                                [attr.aria-expanded]="!submenu2.isCollapsed"
                                                (click)="collapsesubmenu2.toggle();this.ExpandedMenu = true;">
                                                <label class="sub-menu">{{submenu2.MenuLabel}}</label>
                                                <i *ngIf="ExpandedMenu" class="bi me-2 p-1 float-end"
                                                    [ngClass]="{'bi-chevron-down': submenu2.isCollapsed,'bi-chevron-up':!submenu2.isCollapsed}"
                                                    style="font-size: small;"></i>
                                            </span>
                                            <div #collapsesubmenu2="ngbCollapse" [(ngbCollapse)]="submenu2.isCollapsed">
                                                <ul class="pb-1 link-light small" *ngIf="ExpandedMenu">
                                                    @for (submenu3 of submenu2.SubMenus; track setIsCollapsed(submenu3);
                                                    let k =
                                                    $index;) {
                                                    <li class="nav-item"
                                                        (click)="common.selectedmenuID = submenu3.ESS_MenuMasterId;autoExpandedMenu()"
                                                        [routerLink]="[submenu3.URL]" [routerLinkActive]="['active']">
                                                        <span class="nav-link link-light p-1" aria-current="page"
                                                            [attr.aria-expanded]="!submenu3.isCollapsed">
                                                            <label class="sub-sub-menu">{{submenu3.MenuLabel}}</label>
                                                        </span>
                                                    </li>
                                                    }
                                                </ul>
                                            </div>
                                        </li>
                                        }@else{
                                        <li class="nav-item"
                                            (click)="common.selectedmenuID = submenu2.ESS_MenuMasterId;autoExpandedMenu()"
                                            [routerLink]="[submenu2.URL]" [routerLinkActive]="['active']"><span
                                                class="nav-link link-light p-1" aria-current="page"
                                                [attr.aria-expanded]="!submenu2.isCollapsed">
                                                <label class="sub-sub-menu">{{submenu2.MenuLabel}}</label>
                                            </span>
                                        </li>
                                        }
                                        }
                                    </ul>
                                </div>
                            </li>
                            }@else{
                            <!-- <li class="nav-item" [routerLink]="[submenu1.URL]"
                                (click)="common.selectedmenuID = submenu1.ESS_MenuMasterId"
                                [routerLinkActive]="['active']">
                                <span class="nav-link link-light p-1" style="display: inline-flex;" aria-current="page"
                                    [attr.aria-expanded]="!submenu1.isCollapsed">
                                    <label class="sub-menu">{{submenu1.MenuLabel}}</label>
                                    @if(submenu1.ESS_MenuMasterId == 33 || submenu1.ESS_MenuMasterId == 34 ||
                                    submenu1.ESS_MenuMasterId == 35 || submenu1.ESS_MenuMasterId == 47 ||
                                    submenu1.ESS_MenuMasterId == 93
                                    || submenu1.ESS_MenuMasterId == 98|| submenu1.ESS_MenuMasterId == 99||
                                    submenu1.ESS_MenuMasterId == 100|| submenu1.ESS_MenuMasterId == 101 ||
                                    submenu1.ESS_MenuMasterId == 104|| submenu1.ESS_MenuMasterId == 106||
                                    submenu1.ESS_MenuMasterId == 105|| submenu1.ESS_MenuMasterId == 107
                                    ||submenu1.ESS_MenuMasterId == 115|| submenu1.ESS_MenuMasterId == 116
                                    ||submenu1.ESS_MenuMasterId == 120 || submenu1.ESS_MenuMasterId == 140
                                    || submenu1.ESS_MenuMasterId == 121 || submenu1.ESS_MenuMasterId == 141
                                    || submenu1.ESS_MenuMasterId == 133 || submenu1.ESS_MenuMasterId == 142
                                    ||submenu1.ESS_MenuMasterId == 154 || submenu1.ESS_MenuMasterId == 161 || submenu1.ESS_MenuMasterId == 169){
                                    <span class="badge bg-danger link-dark float-end mt-1"
                                        style="font-size: 10px;height: fit-content;">
                                        {{(submenu1.ESS_MenuMasterId ==
                                        33 || submenu1.ESS_MenuMasterId == 98)?common.MenuCounts.Approval.Leave:
                                        (submenu1.ESS_MenuMasterId == 34 || submenu1.ESS_MenuMasterId ==
                                        99)?common.MenuCounts.Approval.Regularization:
                                        (submenu1.ESS_MenuMasterId == 35 || submenu1.ESS_MenuMasterId ==
                                        100)?common.MenuCounts.Approval.Attendance:
                                        (submenu1.ESS_MenuMasterId ==
                                        47)?(common.MenuCounts.Approval.Registration.MenualOnBoard +
                                        common.MenuCounts.Approval.Registration.PreOnBoard):
                                        (submenu1.ESS_MenuMasterId == 93 || submenu1.ESS_MenuMasterId ==
                                        101)?common.MenuCounts.Approval.OptionalHoliday:
                                        (submenu1.ESS_MenuMasterId == 104 || submenu1.ESS_MenuMasterId ==
                                        106)?common.MenuCounts.Approval.CompensatoryOff:
                                        (submenu1.ESS_MenuMasterId == 105 || submenu1.ESS_MenuMasterId ==
                                        107)?common.MenuCounts.Approval.CompensatoryOffConsume:
                                        (submenu1.ESS_MenuMasterId == 115 || submenu1.ESS_MenuMasterId ==
                                        116)?common.MenuCounts.Approval.Reimbursement:
                                        (submenu1.ESS_MenuMasterId == 120 || submenu1.ESS_MenuMasterId ==
                                        140)?common.MenuCounts.Approval.ExpenseAdvance:
                                        (submenu1.ESS_MenuMasterId == 121 || submenu1.ESS_MenuMasterId ==
                                        141)?common.MenuCounts.Approval.Expense:
                                        (submenu1.ESS_MenuMasterId == 133 || submenu1.ESS_MenuMasterId ==
                                        142)?common.MenuCounts.Approval.EmpConfirmation:
                                        (submenu1.ESS_MenuMasterId == 154 || submenu1.ESS_MenuMasterId ==
                                        161)?common.MenuCounts.Approval.Letter:(submenu1.ESS_MenuMasterId == 169)?common.MenuCounts.Approval.Profile:0}}
                                    </span>
                                    }
                                </span>
                            </li> -->
                            <li class="nav-item" [routerLink]="[submenu1.URL]"
                                (click)="common.selectedmenuID = submenu1.ESS_MenuMasterId;autoExpandedMenu()"
                                [routerLinkActive]="['active']">
                                <span class="nav-link link-light p-1" style="display: inline-flex;" aria-current="page"
                                    [attr.aria-expanded]="!submenu1.isCollapsed">
                                    <label class="sub-menu">{{submenu1.MenuLabel}}</label>
                                    <span *ngIf="(submenu1.ESS_MenuMasterId == 33 || submenu1.ESS_MenuMasterId == 34 ||
                                              submenu1.ESS_MenuMasterId == 35 || submenu1.ESS_MenuMasterId == 47 ||
                                              submenu1.ESS_MenuMasterId == 93 || submenu1.ESS_MenuMasterId == 98 ||
                                              submenu1.ESS_MenuMasterId == 99 || submenu1.ESS_MenuMasterId == 100 ||
                                              submenu1.ESS_MenuMasterId == 101 || submenu1.ESS_MenuMasterId == 104 ||
                                              submenu1.ESS_MenuMasterId == 106 || submenu1.ESS_MenuMasterId == 105 ||
                                              submenu1.ESS_MenuMasterId == 107 || submenu1.ESS_MenuMasterId == 115 ||
                                              submenu1.ESS_MenuMasterId == 116 || submenu1.ESS_MenuMasterId == 120 ||
                                              submenu1.ESS_MenuMasterId == 140 || submenu1.ESS_MenuMasterId == 121 ||
                                              submenu1.ESS_MenuMasterId == 141 || submenu1.ESS_MenuMasterId == 133 ||
                                              submenu1.ESS_MenuMasterId == 142 || submenu1.ESS_MenuMasterId == 154 ||
                                              submenu1.ESS_MenuMasterId == 161 || submenu1.ESS_MenuMasterId == 169 || 
                                              submenu1.ESS_MenuMasterId == 271 || submenu1.ESS_MenuMasterId == 273 || submenu1.ESS_MenuMasterId == 286 ||
                                            submenu1.ESS_MenuMasterId == 287 ||submenu1.ESS_MenuMasterId == 295||submenu1.ESS_MenuMasterId == 296) && 
                                       (submenu1.ESS_MenuMasterId == 33 || submenu1.ESS_MenuMasterId == 98 ? 
                                            common.MenuCounts.Approval.Leave :
                                        (submenu1.ESS_MenuMasterId == 34 || submenu1.ESS_MenuMasterId == 99 ? 
                                            common.MenuCounts.Approval.Regularization :
                                        (submenu1.ESS_MenuMasterId == 35 || submenu1.ESS_MenuMasterId == 100 ? 
                                            common.MenuCounts.Approval.Attendance :
                                        (submenu1.ESS_MenuMasterId == 47 ? 
                                            (common.MenuCounts.Approval.Registration.MenualOnBoard +
                                             common.MenuCounts.Approval.Registration.PreOnBoard) :
                                        (submenu1.ESS_MenuMasterId == 93 || submenu1.ESS_MenuMasterId == 101 ? 
                                            common.MenuCounts.Approval.OptionalHoliday :
                                        (submenu1.ESS_MenuMasterId == 104 || submenu1.ESS_MenuMasterId == 106 ? 
                                            common.MenuCounts.Approval.CompensatoryOff :
                                        (submenu1.ESS_MenuMasterId == 105 || submenu1.ESS_MenuMasterId == 107 ? 
                                            common.MenuCounts.Approval.CompensatoryOffConsume :
                                        (submenu1.ESS_MenuMasterId == 115 || submenu1.ESS_MenuMasterId == 116 ? 
                                            common.MenuCounts.Approval.Reimbursement :
                                        (submenu1.ESS_MenuMasterId == 120 || submenu1.ESS_MenuMasterId == 140 ? 
                                            common.MenuCounts.Approval.ExpenseAdvance :
                                        (submenu1.ESS_MenuMasterId == 121 || submenu1.ESS_MenuMasterId == 141 ? 
                                            common.MenuCounts.Approval.Expense :
                                        (submenu1.ESS_MenuMasterId == 133 || submenu1.ESS_MenuMasterId == 142 ? 
                                            common.MenuCounts.Approval.EmpConfirmation :
                                        (submenu1.ESS_MenuMasterId == 154 || submenu1.ESS_MenuMasterId == 161 ? 
                                            common.MenuCounts.Approval.Letter :
                                        (submenu1.ESS_MenuMasterId == 169 ? 
                                            common.MenuCounts.Approval.Profile :
                                        (submenu1.ESS_MenuMasterId == 271 || submenu1.ESS_MenuMasterId == 273 ? 
                                            common.MenuCounts.Approval.Outdoor : 
                                        (submenu1.ESS_MenuMasterId == 286 ? 
                                            common.MenuCounts.Approval.TaxDeclaration : 
                                        (submenu1.ESS_MenuMasterId == 287 ? 
                                            common.MenuCounts.Approval.TaxInvestment : 
                                        (submenu1.ESS_MenuMasterId == 295 ? 
                                            common.MenuCounts.Approval.DeviceImage : 
                                        (submenu1.ESS_MenuMasterId == 296 ? 
                                            common.MenuCounts.Approval.ProfileImage : 0)))))))))))))))))) > 0">
                                        <span class="badge bg-danger link-dark float-end mt-1"
                                            style="font-size: 10px;height: fit-content;">
                                            {{(submenu1.ESS_MenuMasterId == 33 || submenu1.ESS_MenuMasterId ==
                                            98)?common.MenuCounts.Approval.Leave:
                                            (submenu1.ESS_MenuMasterId == 34 || submenu1.ESS_MenuMasterId ==
                                            99)?common.MenuCounts.Approval.Regularization:
                                            (submenu1.ESS_MenuMasterId == 35 || submenu1.ESS_MenuMasterId ==
                                            100)?common.MenuCounts.Approval.Attendance:
                                            (submenu1.ESS_MenuMasterId ==
                                            47)?(common.MenuCounts.Approval.Registration.MenualOnBoard +
                                            common.MenuCounts.Approval.Registration.PreOnBoard):
                                            (submenu1.ESS_MenuMasterId == 93 || submenu1.ESS_MenuMasterId ==
                                            101)?common.MenuCounts.Approval.OptionalHoliday:
                                            (submenu1.ESS_MenuMasterId == 104 || submenu1.ESS_MenuMasterId ==
                                            106)?common.MenuCounts.Approval.CompensatoryOff:
                                            (submenu1.ESS_MenuMasterId == 105 || submenu1.ESS_MenuMasterId ==
                                            107)?common.MenuCounts.Approval.CompensatoryOffConsume:
                                            (submenu1.ESS_MenuMasterId == 115 || submenu1.ESS_MenuMasterId ==
                                            116)?common.MenuCounts.Approval.Reimbursement:
                                            (submenu1.ESS_MenuMasterId == 120 || submenu1.ESS_MenuMasterId ==
                                            140)?common.MenuCounts.Approval.ExpenseAdvance:
                                            (submenu1.ESS_MenuMasterId == 121 || submenu1.ESS_MenuMasterId ==
                                            141)?common.MenuCounts.Approval.Expense:
                                            (submenu1.ESS_MenuMasterId == 133 || submenu1.ESS_MenuMasterId ==
                                            142)?common.MenuCounts.Approval.EmpConfirmation:
                                            (submenu1.ESS_MenuMasterId == 154 || submenu1.ESS_MenuMasterId ==
                                            161)?common.MenuCounts.Approval.Letter:(submenu1.ESS_MenuMasterId ==
                                            169)?common.MenuCounts.Approval.Profile: (submenu1.ESS_MenuMasterId ==
                                            271 || submenu1.ESS_MenuMasterId == 273)?common.MenuCounts.Approval.Outdoor:
                                            (submenu1.ESS_MenuMasterId ==
                                            286)?common.MenuCounts.Approval.TaxDeclaration:(submenu1.ESS_MenuMasterId ==
                                            287)?common.MenuCounts.Approval.TaxInvestment:(submenu1.ESS_MenuMasterId ==
                                            295)?common.MenuCounts.Approval.DeviceImage:(submenu1.ESS_MenuMasterId ==
                                            296)?common.MenuCounts.Approval.ProfileImage:0}}
                                        </span>
                                    </span>
                                </span>
                            </li>
                            }
                            }
                        </ul>
                    </div>
                </li>
                }@else{
                <li [routerLink]="[menu.URL]" (click)="common.selectedmenuID = menu.ESS_MenuMasterId;autoExpandedMenu()"
                    [routerLinkActive]="['active']">
                    <span class="nav-link link-light p-2">
                        <i [ngClass]="menu.Icon" class="p-1" width="16" height="16"></i>
                        <label *ngIf="ExpandedMenu" class="main-menu ms-2">{{menu.MenuLabel}}</label>
                    </span>
                </li>
                }
                }
            </ul>
        </div>
        <!-- <div class="col"></div>
        <div ngbDropdown class="dropdown">
            <div class="bg-primary">
                <a class="nav-link link-light arrow-none nav-user px-2 align-items-center"
                    id="dropdownProfile" href="#" role="button" style="display: inline-flex;" ngbDropdownToggle>
                    <span class="account-user-avatar me-2">
                        <img src="https://preview.keenthemes.com/metronic-v4/theme/assets/pages/media/profile/profile_user.jpg"
                            alt="user-image" width="22" class="rounded-circle">
                    </span>
                    <span class="d-lg-flex flex-column gap-0" *ngIf="ExpandedMenu">
                        <span class="link-light">Matin Mansuri</span>
                    </span>
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdownProfile">
                    <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">Welcome !</h6>
                    </div>

                    <a href="javascript:void(0);" class="dropdown-item">
                        <i class="mdi mdi-account-circle me-1"></i>
                        <span>My Account</span>
                    </a>

                    <a href="javascript:void(0);" class="dropdown-item">
                        <i class="mdi mdi-account-edit me-1"></i>
                        <span>Settings</span>
                    </a>

                    <a href="javascript:void(0);" class="dropdown-item">
                        <i class="mdi mdi-lifebuoy me-1"></i>
                        <span>Support</span>
                    </a>

                    <a href="javascript:void(0);" class="dropdown-item">
                        <i class="mdi mdi-lock-outline me-1"></i>
                        <span>Lock Screen</span>
                    </a>

                    <a href="javascript:void(0);" class="dropdown-item">
                        <i class="mdi mdi-logout me-1"></i>
                        <span>Logout</span>
                    </a>
                </div>
            </div>
        </div> -->
        <!-- <div ngbDropdown class="dropdown">
            <a href="#" class="d-flex align-items-center link-light text-decoration-none dropdown-toggle"
                id="dropdownBookmark" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                <i class="bi bi-bookmark-check me-2 p-1" width="16" height="16"></i>
                <strong *ngIf="ExpandedMenu">Bookmarks</strong>
            </a>
            <ul ngbDropdownMenu class="dropdown-menu text-small shadow" aria-labelledby="dropdownBookmark">
                <li><a class="dropdown-item" href="#">New project...</a></li>
                <li><a class="dropdown-item" href="#">Settings</a></li>
                <li><a class="dropdown-item" href="#">Profile</a></li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" href="#">Sign out</a></li>
            </ul>
        </div> -->
    </div>
    <div class="p-3 col childclass">
        <router-outlet></router-outlet>
    </div>
</main>

<ng-template #dNotification let-offcanvas class="rounded-start">
    <div class="offcanvas-header bg-warning rounded-start">
        <div class="offcanvas-title d-flex">
            <!-- <label>Notification</label> -->
            <select class="ms-1 form-select" aria-label="ALL" placeholder="ALL" title="ALL" name="DropNotification"
                [(ngModel)]="filter.showNotification" #DropNotification="ngModel" (change)="filterNotification()"
                required>
                <option value=0>All</option>
                <option value=1>Read</option>
                <option value=2>Unread</option>
            </select>
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body notification">
        <div class="row" style="display: contents;">
            <div class="row">
                <div class="col-3">
                    <input *ngIf="filter.showNotification != 0" class="form-check-input"
                        style="height: 15px; width: 15px;" name="filter" type="checkbox" value=""
                        (change)="selectAll($event)" [(ngModel)]="ReadUnreadAll" />&nbsp;<label
                        *ngIf="filter.showNotification != 0" style="font-size: 14px;">
                        {{filter.showNotification == 1 ? 'Unread All' : 'Read All'}}
                    </label>
                </div>
                <div class="col-auto ms-auto">
                    <button *ngIf="filter.showNotification != 0" type="button" class="custom-button"
                        (click)="ESS_NotificationInsertUpdat()">{{filter.showNotification == 1
                        ? 'Mark as Unread' : 'Mark as Read'}}</button>
                </div>
            </div>
            <div class="col-12 p-0" style="height: 24rem;">
                <div class="tile m-1" *ngFor="let Notification of Notifications; let i = index">
                    <div class="row p-1 m-1 cursor-pointer"
                        [ngClass]="{'readbg': !Notification['IsRead'],'unreadbg':Notification['IsRead']}">
                        <div class="col-1 p-0" *ngIf="filter.showNotification != 0"><br>
                            <input class="form-check-input" style="height: 15px; width: 15px;" name="filter{{i}}"
                                [(ngModel)]="Notification.selected" (change)="selectRow($event, Notification)"
                                type="checkbox" value="" />
                        </div>
                        <div class="col-2 align-content-center p-0">
                            <img [src]="common.PhotoLink(Notification['Photo'])" alt="user-image" width="35"
                                class="userImage">
                        </div>
                        <div class="col"
                            (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'],true)">
                            <div class="title">
                                <div class="row">
                                    <div class="col">{{Notification['Title']}}</div>
                                    <div class="col-auto badge danger" *ngIf="Notification['ImportantNotification']">
                                        Important</div>
                                </div>
                            </div>
                            <div class="body">{{Notification['NotificationBody']}}</div>
                        </div>
                        <div class="col-auto">
                            <div ngbDropdown>
                                <i role="button" class="bi bi-three-dots-vertical" id="Notificationaction"
                                    ngbDropdownToggle></i>
                                <div ngbDropdownMenu aria-labelledby="Notificationaction" class="p-1" display="dynamic">
                                    <label class="Label cursor-pointer d-block" *ngIf="!Notification['IsRead']"
                                        (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'])">
                                        Mark as Read
                                    </label>
                                    <label class="Label cursor-pointer"
                                        (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'],true)">
                                        Action
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>